import ComprovanteContainer from '@/containers/pedidos/detalhe-comprovante'

const ComprovanteView = () => {
  return <ComprovanteContainer />
}

export default ComprovanteView
